import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { RecurringAgreementStatus } from "@/lib/db-types";

const STATUS_LABEL: Record<RecurringAgreementStatus, string> = {
  active: "Aktiv",
  paused: "Pause",
  ended: "Avsluttet",
};

const STATUS_CLASS: Record<RecurringAgreementStatus, string> = {
  active: "bg-success/10 text-success",
  paused: "bg-amber-100 text-amber-700",
  ended: "bg-muted text-muted-foreground",
};

export function AgreementStatusBadge({ status }: { status: RecurringAgreementStatus }) {
  return (
    <Badge variant="secondary" className={cn("text-xs", STATUS_CLASS[status])}>
      {STATUS_LABEL[status]}
    </Badge>
  );
}
